import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { grey } from "@mui/material/colors";
import { CheckoutContext } from "contexts/Checkout";
import { useContext } from "react";
import { AddOnItemName } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import SeeExample from "../SeeExample";

const styles = {
  card: {
    backgroundColor: "primary.main",
    borderRadius: 3,
    py: 2,
    px: 3,
  },
  saveBundle: {
    ml: 0.5,
    position: "relative",
    top: "-0.5em",
    color: "success.light",
    fontWeight: 700,
    fontSize: 8,
    mt: -4,
  },
};

const PartnershipDataBundle = () => {
  const isMobileScreen = useMediaQuery("(max-width:1600px)");
  const { addOnItems } = useContext(CheckoutContext);
  const { applyAddOnItem } = useCheckout();

  const exists = addOnItems?.find(
    (x) => x.name === AddOnItemName.partnership_data,
  );

  const addToOrderButton = exists ? (
    <Box sx={{ px: 2, fontSize: 10, color: "success.light" }}>
      <strong>
        Added <Box component="i" className="fa-regular fa-check" />
      </strong>
    </Box>
  ) : (
    <Button
      size="small"
      sx={{ color: "secondary.light", ml: 1 }}
      onClick={() =>
        applyAddOnItem({
          name: AddOnItemName.partnership_data,
          quantity: 1,
        })
      }
    >
      + Add
    </Button>
  );

  return (
    <Grid sx={{ mt: 2 }}>
      {!isMobileScreen && (
        <Typography
          textAlign="center"
          sx={{ fontSize: 12, my: 1, color: grey[500] }}
        >
          Recommended for you
        </Typography>
      )}
      <Grid sx={styles.card} container alignItems="center">
        {!isMobileScreen && (
          <Grid container item lg={3} xl={2} sx={{ ml: -2 }}>
            {addToOrderButton}
          </Grid>
        )}
        <Grid item xs>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 1 }}
          >
            <Typography variant="h6" sx={{ color: "white", fontSize: 16 }}>
              <strong>Make it a Bundle: Partnership Data 🌟 </strong>
            </Typography>

            <SeeExample theme="light" />
          </Grid>

          <Typography sx={{ color: "white", fontSize: 12 }} gutterBottom>
            $8/month{" "}
            <Box component="span" sx={styles.saveBundle}>
              SAVE 20%
            </Box>
          </Typography>
          <Typography sx={{ color: grey[500] }}>
            Level up your pitching game and get exclusive information about
            brand partnerships
          </Typography>

          {isMobileScreen && (
            <Box sx={{ mt: 2, ml: -2 }}>{addToOrderButton}</Box>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PartnershipDataBundle;
